import { idToStrongId } from "@oysterhr/common"
import { companyBasePath } from "@oysterhr/router"
import { CountryIntelligenceOysterScore, CountryIsoCode } from "@oysterhr/schema"
import { stringify } from "query-string"
import { generatePath } from "react-router-dom"
import { UpdateHiringFTEFormPageSteps } from "../../pages/UpdateHiringFTEFormPage/hooks/useParamsFromUpdateHiringFTEFormPage"

const _baseHiresPath = (path: string, employmentId?: string) => {
  return generatePath("hires/:employmentId/*", {
    employmentId: idToStrongId(employmentId || ""),
    "*": path,
  })
}

const _baseHireTemplatePath = (templateId?: string) => {
  return generatePath("hires/new/full-time-template/:templateId", {
    templateId: idToStrongId(templateId || ""),
  })
}

export const companyHiringFTEDetailsPath = (
  companyId: string,
  employmentId: string,
  stepName?: UpdateHiringFTEFormPageSteps,
) =>
  companyBasePath({
    companyId,
    path: _baseHiresPath("details", employmentId),
    query: stepName && `section=${stepName}`,
  })

export const companyHiringFTEEditPath = (
  companyId: string,
  employmentId: string,
  stepName: UpdateHiringFTEFormPageSteps,
  redirectUrl?: string,
) =>
  companyBasePath({
    companyId,
    path: _baseHiresPath(`details/edit/${stepName}`, employmentId),
    query: redirectUrl,
  })

export const companyHiringFTEOvertimeDetailsPath = (
  companyId: string,
  employmentId: string,
  redirectUrl?: string,
) =>
  companyBasePath({
    companyId,
    path: _baseHiresPath("overtime-details", employmentId),
    query: redirectUrl && `redirectTo=${redirectUrl}`,
  })

export const companyGetFTEWizardPath = (
  companyId: string,
  {
    employmentId,
    query,
  }: {
    employmentId?: string
    query?: {
      countryCode?: CountryIsoCode
      oysterScore?: CountryIntelligenceOysterScore | null
      templateId?: string | null
      subscriptionPlanId?: string
    }
  } = {},
) => {
  const path = employmentId ? "edit" : "new/full-time"

  return companyBasePath({
    companyId,
    path: _baseHiresPath(path, employmentId),
    query: stringify(query || {}),
  })
}

export const companyNewHireFTESelectTemplatePath = (
  companyId: string,
  {
    query,
  }: {
    query?: {
      countryCode?: CountryIsoCode
      subscriptionPlanId?: string
    }
  } = {},
) =>
  companyBasePath({
    companyId,
    path: _baseHireTemplatePath(),
    query: stringify(query || {}),
  })

export const companyTemplateDetailsModalPath = (
  companyId: string,
  templateId: string,
  query?: {
    countryCode?: CountryIsoCode
    oysterScore?: CountryIntelligenceOysterScore | null
    subscriptionPlanId?: string
  },
) =>
  companyBasePath({
    companyId,
    path: _baseHireTemplatePath(templateId),
    query: stringify(query || {}),
  })
